// extracted by mini-css-extract-plugin
module.exports = {"section":"L_section__7nDT6"};